import {
  StyleSheet,
  Image,
  Text,
  View,
  Button,
  SafeAreaView,
} from "react-native";
import { ScrollView, TouchableOpacity } from "react-native-gesture-handler";
import { Entypo } from "@expo/vector-icons";
import { Ionicons } from "@expo/vector-icons";
import BookCard from "./BookCard";
import { useEffect, useRef, useState } from "react";
import { Picker } from "@react-native-picker/picker";
import cover from "../assets/bookcover.png";
import { StatusBar } from "react-native";
import {
  Menu,
  MenuOptions,
  MenuOption,
  MenuTrigger,
} from "react-native-popup-menu";


const BookCollection = (props) => {
  const [selectedLanguage, setSelectedLanguage] = useState("Amharic");

  const pickerRef = useRef();
  function open() {
    pickerRef.current.focus();
  }

  const language = [
    {
      key: 1,
      label: "Amharic",
      value: "AmharicBooklet",
      onPress: () => {
        setSelectedLanguage("AmharicBooklet");
      },
    },
    {
      key: 2,
      label: "English",
      value: "AmharicPage",
    },
    {
      key: 3,
      label: "Somali",
      value: "AmharicPage",
    },
    {
      key: 4,
      label: "Oromifa",
      value: "AmharicPage",
    },
    {
      key: 5,
      label: "Sidamic",
      value: "AmharicPage",
    },
  ];

  return (
    <SafeAreaView style={styles.container}>
      <StatusBar
        barStyle="light-content"
        hidden={false}
        backgroundColor="#192655"
        translucent={false}
        networkActivityIndicatorVisible={true}
        animated={true}
      />
      <View style={styles.header}>
        <TouchableOpacity onPress={() => props.navigation.goBack()}>
          <Entypo name="chevron-left" color="#fff" size={25} />
        </TouchableOpacity>
        <TouchableOpacity onPress={() => props.navigation.navigate("About")}>
          {/* <Menu>
            <MenuTrigger> */}
              <Ionicons name="ellipsis-vertical" size={24} color="#fff" />
            {/* </MenuTrigger>
            <MenuOptions customStyles={optionsStyles}>
              <MenuOption onSelect={() => props.navigation.navigate("About")}>
                <Text
                  style={{
                    marginTop: "5%",
                    marginBottom: "5%",
                    marginLeft: "5%",
                    fontWeight: "bold",
                  }}
                >
                  About US
                </Text>
              </MenuOption>
              <MenuOption>
                <Text
                  style={{
                    marginTop: "5%",
                    marginBottom: "5%",
                    marginLeft: "5%",
                    fontWeight: "bold",
                  }}
                >
                  Resources
                </Text>
              </MenuOption>
              
            </MenuOptions>
          </Menu> */}
        </TouchableOpacity>
      </View>
      <View style={styles.cont}>
        <Text
          style={{
            fontSize: 20,
            fontWeight: "bold",
            color: "#fff",
            marginTop: 20,
          }}
        >
          Book Collections
        </Text>
      </View>
      <View style={{ flex: 1, flexDirection: "row" }}>
        <ScrollView style={{ marginTop: 40, paddingVertical: 50 }}>
          <View
            style={{
              flex: 1,
              flexDirection: "column",
              justifyContent: "flex-end",
            }}
          >
            {language.map((item, index) => (
              <TouchableOpacity
                key={index}
                onPress={() => setSelectedLanguage(item.label)}
              >
                <Text
                  style={{
                    ...styles.side,
                    color: selectedLanguage === item.label ? "#fff" : "#B6BBC4",
                  }}
                >
                  {item.label}
                </Text>
              </TouchableOpacity>
            ))}
          </View>
        </ScrollView>

        <ScrollView style={{ marginTop: 40 }}>
          {selectedLanguage === "Amharic" ? (
            <View>
              <BookCard
                onPress={() => props.navigation.navigate("AmharicBooklet")}
                img={cover}
                title="በት/ት ገበታ ላይ ያሉ ልጆችን  የተመለከተ ጥራዝ"
                read="አሳይ"
                bg="#5272F2"
              />

              <BookCard
                onPress={() => props.navigation.navigate("AmharicBooklet")}
                img={cover}
                title="Fracture Management Books"
                read="Coming Soon"
                bg="#DA0C81"
              />
              {/* <BookCard
                onPress={() => props.navigation.navigate("AmharicBooklet")}
                img={cover}
                title=""
                read=""
                bg="#FFE382"
              /> */}
            </View>
          ) : null}
          {selectedLanguage === "English" ? (
            <View>
              <BookCard
                onPress={() => props.navigation.navigate("EnglishBooklet")}
                img={cover}
                title="School Children's Booklet"
                read="View"
                bg="#5272F2"
              />
              <BookCard
                onPress={() => props.navigation.navigate("EnglishBooklet")}
                img={cover}
                title="Fracture Management Books"
                read="Coming Soon"
                bg="#DA0C81"
              />
              {/* <BookCard
                onPress={() => props.navigation.navigate("Detail")}
                img={cover}
                title=""
                read=""
                bg="#FFE382"
              /> */}
            </View>
          ) : null}
          {selectedLanguage === "Somali" ? (
            <View>
              <BookCard
                onPress={() => props.navigation.navigate("SomaliBooklet")}
                img={cover}
                title="Buug yaraha caruurta dugsiga dhigata"
                read="Aragti"
                bg="#5272F2"
              />
              <BookCard
                onPress={() => props.navigation.navigate("Detail")}
                img={cover}
                title="Fracture Management Books"
                read="Coming Soon"
                bg="#DA0C81"
              />
              {/* <BookCard
                onPress={() => props.navigation.navigate("Detail")}
                img={cover}
                title=""
                read=""
                bg="#FFE382"
              /> */}
            </View>
          ) : null}
          {selectedLanguage === "Oromifa" ? (
            <View>
              <BookCard
                onPress={() => props.navigation.navigate("OromifaBooklet")}
                img={cover}
                title="Barruu gabaabaa ijoollee barumsa irra jiranii"
                read="Ilaaluu"
                bg="#5272F2"
              />
              <BookCard
                onPress={() => props.navigation.navigate("Detail")}
                img={cover}
                title="Fracture Management Books"
                read="Coming Soon"
                bg="#DA0C81"
              />
              {/* <BookCard
                onPress={() => props.navigation.navigate("Detail")}
                img={cover}
                title=""
                read=""
                bg="#FFE382"
              /> */}
            </View>
          ) : null}
          {selectedLanguage === "Sidamic" ? (
            <View>
              <BookCard
                onPress={() => props.navigation.navigate("SidamignaBooklet")}
                img={cover}
                title="Rosu aana noo ooso maxaaficho"
                read="Leellishi"
                bg="#5272F2"
              />
              <BookCard
                onPress={() => props.navigation.navigate("Detail")}
                img={cover}
                title="Fracture Management Books"
                read="Coming Soon"
                bg="#DA0C81"
              />
              {/* <BookCard
                onPress={() => props.navigation.navigate("Detail")}
                img={cover}
                title=""
                read=""
                bg="#FFE382"
              /> */}
            </View>
          ) : null}
        </ScrollView>
      </View>
    </SafeAreaView>
  );
};

export default BookCollection;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#192655",
    // width: "100%",
  },
  header: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: "#192655",
    width: "100%",
    paddingHorizontal: 20,
    paddingTop: 20,
  },
  side: {
    // color: "white",
    // paddingTop: 10,
    flex: 1,
    // justifyContent: "flex-end",
    padding: 10,
    width: 90,
    height: 40,
    color: "#fff",
    backgroundColor: "#192655",
    borderColor: "#192655",
    paddingStart: 12,
    paddingEnd: 12,
    // borderRadius: 10,
    alignItems: "center",
    marginVertical: 20,
    // borderWidth: 0.5,
    transform: [{ rotate: "-90deg" }],
  },
});

const optionsStyles = {
  optionsContainer: {
    backgroundColor: '#fff',
    // padding: 5,
    marginTop: 30,
    width: 90,
  },
};
